import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';

import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import swal from 'sweetalert';
import $ from 'jquery';
import MultiDropDown from '../Components/MultiDropdown';

var imgPrefix = `${SERVER_IP}/icons`
class CorporateLogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Lists: {},
            user_action: "view",
            tempList: {},
            image: ""
        }
    }


    viewInfo = () => {
        var data = {
            s_id: "",
            user_id: ud.id,
            user_type: ud.usertype
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersList`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.usersList) {
                        if (response.data.usersList.length == 1) {
                            _this.setState({ Lists: response.data.usersList[0], tempList: response.data.usersList[0], message: response.data.usersList.length === 0 ? "No Record Found." : "" });
                        }
                    }
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.viewInfo();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    componentDidMount() {
        this.viewInfo();

        // this.getTotalType()
        var current = this
        $(".btnrating").on('click', (function (e) {

            var previous_value = $("#selected_rating").val();

            var selected_value = $(this).attr("data-attr");
            current.setState({ rating: selected_value })
            $("#selected_rating").val(selected_value);

            $(".selected-rating").empty();
            $(".selected-rating").html(selected_value);

            for (var i = 1; i <= selected_value; ++i) {
                $("#rating-star-" + i).toggleClass('btn-warning');
                $("#rating-star-" + i).toggleClass('btn-default');
            }

            for (var ix = 1; ix <= previous_value; ++ix) {
                $("#rating-star-" + ix).toggleClass('btn-warning');
                $("#rating-star-" + ix).toggleClass('btn-default');
            }

        }));
    }
    getTotalType = () => {
        var data = {
            jwt: jwt,
            s_id: ud.main_id
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        var heirarchy = this.state.heirarchy
        axios.post(`${SERVER_IP}/view/typesfordropdown`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    var r = _this.convert(response.data.result.result)
                    var temparr = [];
                    r.map((list, index) => { temparr.push([]) })
                    _this.setState({ typeHierarchy: r, dynamicSelectedType: temparr });
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalType();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    onChangeDropdownDepartment = (currentNode, selectedNodes) => {

        this.setState({ departmentSelected: selectedNodes })
    }
    onChangeDropdownEquipment = (currentNode, selectedNodes) => {
        this.setState({ equipmentSelected: selectedNodes })

    }
    onChangeDropdownUnit = (currentNode, selectedNodes) => {
        this.setState({ unitSelected: selectedNodes })
    }
    onAction = (node, action) => {
        // console.log('onAction::', action, node)
    }
    onNodeToggle = currentNode => {
        // console.log('onNodeToggle::', currentNode)
    }
    onChangeDropdown = (index, currentNode, selectedNodes) => {
    
        this.state.dynamicSelectedType[index] = selectedNodes;
        this.setState(this.state)
    }
    onChangeInput = (e) => {
        e.preventDefault();
        this.state.tempList[e.target.name] = e.target.value
        this.setState(this.state)
    }
    Edit = () => {
        if (this.state.image == "") {
            return
        }
        var data = {
            name: this.state.tempList.name,
            cooperate_name: this.state.tempList.cooperate_name,
            phone: this.state.tempList.phone,
            cooperate_logo: this.state.image,
            user_type: 1,
            address: this.state.tempList.address,
            user_id: this.state.Lists.login_id,
            main_id: this.state.Lists.id,
            city: this.state.tempList.city,
            state: this.state.tempList.state,
            details: this.state.tempList.details,
            zip: this.state.tempList.zip,
        }
        var _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/create/c_s_edit`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error == false) {
                        swal("Update Successfully", "You can see the latest update after new login", "success")
                        _this.viewInfo();
                        _this.setState({ user_action: "view" });
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.Edit();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                image: reader.result
            });

        };
    }
    render() {
        const { errors } = this.state;
        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div className="col-md-6">
                            <h4 class="xp-page-title">Corporate Logo</h4>
                        </div>
                        <div class="col-md-12">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    <li class="breadcrumb-item active" onClick={() => window.location.href = "/create/listuser"}>List Users</li>
                                </ol>
                            </div>
                         </div>
                        <div class="col-md-6 col-lg-6 mt-4">
                            {this.state.user_action != "edit" ?
                                <button className="btn btn-primary btn-lg" title="Create new" onClick={() => this.setState({ user_action: "edit" })}><i className="mdi mdi-plus mr-2"></i>Add Logo</button>
                                :
                                <button className="btn btn-primary btn-lg" title="Create new" onClick={() => this.setState({ user_action: "view" })}><i className="mdi mdi-plus mr-2"></i>View Corporate Logo</button>
                            }
                        </div>
                    </div>

                    {this.state.user_action != "edit" ?
                        <div className="xp-contentbar px-0 pt-3">
                            <div className="row">
                                <div className="col-md-12">
                                <div className="card m-b-30">
                                    <div className="card-header bg-primary">
                                        <h5 className="card-title text-white">Corporate Logo</h5>
                                    </div>
                                    <div className="card-body ">
                                        <div class="xp-social-profile-middle text-center">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="xp-social-profile-avatar text-center">
                                                        <img src={`${imgPrefix}/${this.state.Lists.cooperate_logo}`} alt="user-profile" class="rounded-circle img-fluid" style={{ height: "200px" }} />
                                                    </div>
                                                    <div class="xp-social-profile-title">
                                                        <h5 class="my-1 text-black">{this.state.Lists.name}</h5>
                                                    </div>
                                                    <div class="xp-social-profile-subtitle">
                                                        <p class="mb-3 text-muted">{this.state.Lists.details}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <ul className="profile-list">
                                            <p style={{ textAlign: "justify" }}><big><b>Note: </b></big>
                                            The updated Logo will not be used in the previous reports from the date of Logo change”
                                            </p>
                                        </ul>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card-body m-b-30">

                            <div className="form-row">

                                <div className="form-group col-md-12">
                                    <label for="exampleInputEmail1">Profile Image</label>
                                    <div className="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i className="mdi mdi-file-image"></i></span>
                                        </div>
                                        <input type="file" onChange={this.handleImageChange} name="logo" className="form-control" placeholder="Upload Image" accept="image/*" />
                                    </div>
                                    <div className="input-group">
                                        <img src={this.state.image} />
                                    </div>
                                </div>
                            </div>
                            <ul className="profile-list">
                                <p style={{ textAlign: "justify" }}><big><b>Note: </b></big>
                                    This is your Corporate logo. If you change it then it will reflect all the further workflow reports. Also the same as in all dashboards.
                                            </p>
                            </ul>

                            <button type="submit" onClick={this.Edit} className="btn btn-primary">Save</button>
                        </div>
                    }
                </div>
            </div>


        )
    }
}
export default CorporateLogo

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}